// extracted by mini-css-extract-plugin
export default {"AttachmentsList":"AttachmentsList-module-bb65798523e28ec4af28","horizontalScroll":"AttachmentsList-module-f9992a19d88fa4287f3e"};